export const AUTH_TOKEN_KEY = "lainternacional_token";
export const AUTH_USER_KEY = "lainternacional_user";
export const AUTH_EXPIRED_EVENT = "lainternacional:auth-expired";

const decodeJwtPayload = (token) => {
  try {
    const payload = String(token || "").split(".")[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = window.atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, "="));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};

export const clearStoredSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};

export const getStoredToken = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) return null;

  const payload = decodeJwtPayload(token);
  const expiraEn = Number(payload?.exp || 0) * 1000;
  if (!payload || !expiraEn || expiraEn <= Date.now()) {
    clearStoredSession();
    return null;
  }

  return token;
};

export const getStoredUser = () => {
  if (!getStoredToken()) return null;
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    localStorage.removeItem(AUTH_USER_KEY);
    return null;
  }
};

export const storeSession = (token, usuario) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(usuario));
};

export const notifyExpiredSession = () => {
  clearStoredSession();
  window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
};
